module.exports = __webpack_public_path__ + "fonts/Calibre-ThinItalic.4422e763.woff";